export const GEO_ID = 'CN';
export const AIRLINE_PROFILE = 'all';
export const MAX_COUNT_POLLING_CHECKP_PRICE = 5;
export const GAP_POLLING_CHECKP_PRICE = 3000;
export const SEARCH_TYPE = 'bundled';
export const USER_TYPE_MEMBER = 'MEMBER';
